import React from 'react'
import * as api from '../../api';
import * as qs from "query-string";
import { toast } from 'react-toastify';
import { FilePond } from 'react-filepond';
import { AuthService } from '../../services/auth-service'
import { apiUrl } from "../../config.js"
import DatePicker from "react-datepicker"
import { withRouter } from "react-router-dom";
import "./sites.scss"
import { Grid, Header, Segment, Popup, TextArea, Button, Input, Modal, Dropdown, Select, Form, Dimmer, Loader, Message, Icon, Checkbox, Tab } from 'semantic-ui-react';
import { translateSiteName } from "../../helpers/data-helpers";
import Field from "../../components/forms/field";
import { NoData } from "../../components/table/no-data";
import HelpSection from '../about/HelpSection';


const authService = new AuthService();


class UpdateSiteModel extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            uploadStatusList: ["error1", "error2"],
            meterModalOpen: false,
            submittingInProgress: false,
            showErrorHide: true,
            showSiteSale: false,
            showSiteDocsWarning: false,
            allowSubmit: true,
            hideMetersList: true,
            hideRemoveMetersList: true,
            showSuccessHide: true,
            contactCopied : false,
            previousOccupierName: '',
            previousOccupierContact: '',
            meterAddress:'',
            changeDate: '',
            currentSiteName: translateSiteName(this.props.currentSite),
            markSiteAsSold: false,
            currentSite: '',
            customerId: authService.getUserData(AuthService.CUSTOMER_ID_KEY),
            params: qs.parse(this.props.location.search),
            utility: '',
            mpanmpr: '',
            meterserial: '',
            supplierName: '',
            openingMeterReads: '',
            firstTabMSK: '',
            hideMoveoutDetails: false,
            meters: [
                // { id : 1, utility : 'hello', mpanmpr : 'yeah', supplierName : 'france', openingmeterreads : '888' },
                // { id : 2, utility : 'hello2', mpanmpr : 'yeah3', supplierName : 'france4', openingmeterreads : '8882' }
            ],
            metersToRemoveSubmissionObject: [],
            metersToRemove: [],
            metersList: [],
            fileList: [],
            meterListAll: [],
            prevFileNames: [],
            prevFileList: [],
            cotsAccess : authService.getUserData(AuthService.COTSACCESS),
            isLiquidationForfeiture: false

        }

    }

    componentDidMount = () => {
        this.fetchData().then(() => {
            if (this.state.params.removeMeterKey !== undefined) {
                this.setOpen(true)
                this.onloadMeters(this.state.params.removeMeterKey)

            }

            if (this.state.params.updateMeterKey !== undefined) {
                this.setOpen(true)

                this.setState({
                    meters: [],
                    hideMetersList: true,
                    hideRemoveMetersList: true,
                    markSiteAsSold: false,
                    changeRequested: "Other"

                });

            }

            if (this.state.params.queue !== undefined) {
            

                return Promise.all([
                    api.GetLogSiteUpdate(this.state.params.queue),
                ])
                    .then(([cotDetails]) => {


                        this.setOpen(true)

                        var fileListTemp = (cotDetails.fileString === '[]' ? [] : JSON.parse(cotDetails.fileString))
                        fileListTemp.forEach(function (part, index, theArray) {
                            theArray[index] = theArray[index].substring(theArray[index].lastIndexOf('\\') + 1);
                        });

                       


                        var metersToRemoveResumeArr = []


                        var metersToRemoveSubmissionTemp = JSON.parse(cotDetails.metersToRemoveSubmissionString)


                        metersToRemoveSubmissionTemp.forEach((meterArry, index) => {

                            let filtereedArray = this.state.metersList.filter(meter => meter.meterSiteKey === meterArry.meterSiteKey);

                            if (filtereedArray.length > 0) {
                                metersToRemoveResumeArr.push(filtereedArray[0])
                            }
                            let fileMeterListMaster = meterArry.fileList

                            var fileMeterListTemp = (meterArry.fileList === '[]' ? [] : meterArry.fileList)
                            var tempMeterListOut = [];
                            fileMeterListTemp.forEach(function (part, index, theArray) {
                                if (theArray[index] !== undefined) {
                                    tempMeterListOut.push(
                                        theArray[index].substring(theArray[index].lastIndexOf('\\') + 1)); //FOr some reason this was updating any assigned value using fileList....???
                                }
                            });


                            this.setState({
                                ["newBillingAddress|" + meterArry.meterSiteKey]: meterArry.newBillingAddress,
                                ["newOccupierName|" + meterArry.meterSiteKey]: meterArry.newOccupierName,
                                ["newOccupierContact|" + meterArry.meterSiteKey]: meterArry.newOccupierContact,
                                ["FinalMeterRead|" + meterArry.meterSiteKey]: meterArry.FinalMeterRead,
                                ["prevFileList|" + meterArry.meterSiteKey]: fileMeterListMaster,
                                ["prevFileNames|" + meterArry.meterSiteKey]: tempMeterListOut,
                                ["meterFileStrings|" + meterArry.meterSiteKey]: []

                            });

                        });


                        var parts = cotDetails.changeDate.split("/");
                        var dt = new Date(parseInt(parts[2], 10),
                            parseInt(parts[1], 10) - 1,
                            parseInt(parts[0], 10));

                        this.setPageLayout(cotDetails.changeRequested)

                        var summary = "";


                        if (cotDetails.changeRequested !== "removeMeter" && cotDetails.changeRequested !== "newMeter" && cotDetails.changeRequested !== "moveOut") {
                            summary = cotDetails.changeRequested
                            cotDetails.changeRequested = "Other"

                        }

                        this.setState({
                            markSiteAsSold: cotDetails.markSiteAsSold,
                            changeRequested: cotDetails.changeRequested,
                            actualChangeDate: cotDetails.changeDate,
                            changeDate: dt,
                            changeSummary: summary,
                            siteDetailAddress: cotDetails.siteDetailAddress,
                            comments: cotDetails.comments,
                            metersToRemove: metersToRemoveResumeArr,
                            meters: (cotDetails.meterstring === '[]' ? [] : JSON.parse(cotDetails.metersString)),
                            metersToRemoveSubmissionObject: (cotDetails.meterstring === '[]' ? [] : JSON.parse(cotDetails.metersToRemoveSubmissionString)),
                            prevFileList: JSON.parse(cotDetails.fileString),
                            prevFileNames: fileListTemp


                            // (cotDetails.meterAddress !== null ? cotDetails.meterAddress : ""),

                        })
                    });
            }
        });




    };

    fetchData = () => {
        return Promise.all([
            api.getSitesMeters(this.state.customerId, this.state.params.siteKey),
            api.getMetersList(this.state.customerId),
        ])
            .then(([metersList, MeterListAll]) => {
                this.setState({
                    metersList: metersList.data, meterListAll: MeterListAll
                })

            });
    };

    setOpen = (open) => {
        if (open === false) {
            this.setState({
                showInfoHide: false,
                showErrorHide: true,
                showSuccessHide: true,
                showSiteDocsWarning: false,
                meterModalOpen: false
            });
        }
        this.setState({
            meterModalOpen: open
        });
    }

    setOpenClearHistory = (id,queue) => {
        this.setState({
            showInfoHide: false,
            showErrorHide: true,
            showSuccessHide: true,
            showSiteDocsWarning: false,
            meterModalOpen: false
        });
        this.props.history.push("/cotqueue?qid=" + id + "&queue=" + queue);
        //window.location.reload();
    }




    handleChange = event => {

        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleCheckboxChange = () => {
        this.setState((prevState) => ({
            isLiquidationForfeiture: !prevState.isLiquidationForfeiture,
            previousOccupierName: !prevState.isLiquidationForfeiture ? "not required for request" : "",
            previousOccupierContact: !prevState.isLiquidationForfeiture ? "not required for request" : "",
        }));
    };

    handleMeterArrayChange = event => {

      

        var meterSplit = event.target.name.split("|")



        let myArr = [...this.state.metersToRemoveSubmissionObject]

        let filtereedArray = myArr.filter(meter => meter.meterSiteKey !== meterSplit[1]);

        var firstMSK = myArr[0].meterSiteKey

        let objectAssociatedData = filtereedArray

        var newBillingAddress = (meterSplit[0] === "newBillingAddress" ? event.target.value : this.state["newBillingAddress|" + meterSplit[1]])
        var newOccupierName = (meterSplit[0] === "newOccupierName" ? event.target.value : this.state["newOccupierName|" + meterSplit[1]])
        var newOccupierContact = (meterSplit[0] === "newOccupierContact" ? event.target.value : this.state["newOccupierContact|" + meterSplit[1]])

         



        var FinalMeterRead = (meterSplit[0] === "FinalMeterRead" ? event.target.value : this.state["FinalMeterRead|" + meterSplit[1]])
        var fileList = this.state["meterFileStrings|" + meterSplit[1]]
        var prevFileList = this.state["prevFileList|" + meterSplit[1]]


        if (firstMSK === meterSplit[1]) {
            objectAssociatedData.unshift({
                id: Math.random(), meterSiteKey: meterSplit[1],
                newBillingAddress: newBillingAddress, newOccupierName: newOccupierName, newOccupierContact: newOccupierContact, FinalMeterRead: FinalMeterRead, fileList: fileList, prevFileList: prevFileList
            })
        } else {
            objectAssociatedData.push({
                id: Math.random(), meterSiteKey: meterSplit[1],
                newBillingAddress: newBillingAddress, newOccupierName: newOccupierName, newOccupierContact: newOccupierContact, FinalMeterRead: FinalMeterRead, fileList: fileList, prevFileList: prevFileList
            })
        }

        this.setState({
            metersToRemoveSubmissionObject: objectAssociatedData,
        })

        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleDropDownChange = (event, data) => {


        this.setState({
            [data.name]: data.value
        });

    }

    onloadMeters = (meterSiteKey) => {


        this.setState({
            meters: [],
            hideMetersList: true,
            hideRemoveMetersList: false,
            markSiteAsSold: false,
            changeRequested: "removeMeter"

        });

        let myArr = [...this.state.metersToRemove]


        let filtereedArray = this.state.metersList.filter(meter => meter.meterSiteKey === meterSiteKey);

        if (filtereedArray.length > 0) {
            myArr.push(filtereedArray[0])


            this.setState({
                metersToRemove: myArr
            })

            let objectAssociatedData = [...this.state.metersToRemoveSubmissionObject]

            objectAssociatedData.push({ id: Math.random(), meterSiteKey: meterSiteKey, newBillingAddress: "", newOccupierName: "", newOccupierContact: "", FinalMeterRead: "", fileList: [] })


            if (this.state["meterFileStrings|" + meterSiteKey] !== undefined) {
                this.setState({
                    metersToRemoveSubmissionObject: objectAssociatedData
                })
            }
            else {
                this.setState({
                    metersToRemoveSubmissionObject: objectAssociatedData,
                    ["meterFileStrings|" + meterSiteKey]: [],
                    ["prevFileList|" + meterSiteKey]: [],

                })
            }


            if (myArr.length === this.state.metersList.length) {
                this.setState({ showSiteSale: !this.state.showSiteSale })
            } else {
                this.setState({ markSiteAsSold: false })
            }
        }
    }

    setPageLayout = (changeRequessted) => {
        if (changeRequessted === "removeMeter") {
            this.setState({
                meters: [],
                hideMetersList: true,
                hideMoveoutDetails: false,

                hideRemoveMetersList: false,
                markSiteAsSold: false
            });
        } else if (changeRequessted === "newMeter") {
            this.setState({
                metersToRemove: [],
                hideMetersList: false,
                hideMoveoutDetails: true,

                hideRemoveMetersList: true,
                markSiteAsSold: false
            });
        } else if (changeRequessted === "Other") {
            this.setState({
                metersToRemove: [],
                hideMoveoutDetails: true,
                meters: [],
                hideMetersList: true,
                hideRemoveMetersList: true,
                markSiteAsSold: false
            });
        } else //MoveOut
        {
            this.setState({
                metersToRemove: this.state.metersList,
                hideMoveoutDetails: false,
                hideMetersList: true,
                hideRemoveMetersList: true,
                markSiteAsSold: true
            });
        }
    }

    handleChangeOption = (event, data) => {


        this.setPageLayout(data.value)

        this.setState({
            [data.name]: data.value
        });

    }

    handleDateChange = (newDate) => {

        this.setState({
            changeDate: newDate,
            actualChangeDate: newDate.toLocaleDateString('en-GB')
        });

    };

    fromDateChanged = (newDate) => {
    }

    onFilesUpdated = (fileItems) => {
        this.setState({
            files: fileItems.map(fileItem => fileItem.file)
        });

    };

    onFilesUpdatedMeters = (fileItems) => {


        this.setState({
            ["meterFiles|" + this.state.currentMeterTab]: fileItems.map(fileItem => fileItem.file)
        });

    };


    handleRemoveMeter = (name, value) => {

        let myArr = [...this.state.meters]

        let filtereedArray = myArr.filter(({ id }) => id !== value.id);

        this.setState({
            meters: filtereedArray
        })
    };

    handleRemoveActualMeter = (name, value) => {

        let myArr = [...this.state.metersToRemove]

        let filtereedArray = myArr.filter(meter => meter.meterSiteKey !== value.id);

        this.setState({
            metersToRemove: filtereedArray,
            markSiteAsSold: false
        })
    };

    handleAddActualMeter = (name, value) => {

        let myArr = [...this.state.metersToRemove]

        let filtereedArray = this.state.metersList.filter(meter => meter.meterSiteKey === value.id);

        myArr.push(filtereedArray[0])


        this.setState({
            metersToRemove: myArr
        })


        let objectAssociatedData = [...this.state.metersToRemoveSubmissionObject]

        objectAssociatedData.push({ id: Math.random(), meterSiteKey: value.id, newBillingAddress: "", newOccupierName: "", newOccupierContact: "", FinalMeterRead: "", fileList: [] })


        if (this.state["meterFileStrings|" + value.id] !== undefined) {
            this.setState({
                metersToRemoveSubmissionObject: objectAssociatedData
            })
        }
        else {
            this.setState({
                metersToRemoveSubmissionObject: objectAssociatedData,
                ["meterFileStrings|" + value.id]: []
            })
        }

        if (myArr.length === this.state.metersList.length) {
            this.setState({ showSiteSale: !this.state.showSiteSale })
        } else {
            this.setState({ markSiteAsSold: false })
        }

    };

    pushAllMeters = () => {


        let myArr = this.state.metersList//.filter(meter => meter.meterSiteKey === value.id);

        this.setState({
            metersToRemove: myArr
        })


        let objectAssociatedData = [...this.state.metersToRemoveSubmissionObject]

        myArr.forEach(x => {

            objectAssociatedData.push({ id: Math.random(), meterSiteKey: x.meterSiteKey, newBillingAddress: "", newOccupierName: "", newOccupierContact: "", FinalMeterRead: "", fileList: [] })


            if (this.state["meterFileStrings|" + x.meterSiteKey] === undefined) {
                this.setState({
                    ["meterFileStrings|" + x.meterSiteKey]: []
                })

            }


        });
        this.setState({
            metersToRemoveSubmissionObject: objectAssociatedData
        })


    };


    handleMeterRender = (MeterID) => {
  
        let myArr = [...this.state.metersToRemove]



        let filtereedArray = myArr.filter(meter => meter.meterSiteKey === MeterID);

        if (filtereedArray.length > 0) {
            return true
        } else {
            return false
        }
    };

    notify = (message, error = false, refresh = false) => {
        if (error) {
            toast.error(message, {
                position: toast.POSITION.TOP_CENTER,
                delay: 50,
                autoClose: false
            });
        } else if (refresh) {
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: false,
                onClose: () => {
                    this.props.history.push("/");
                    window.location.reload();
                }
            });
        } else {
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: false,
                closeOnClick: false
            });
        }
    }

    isAlphaNumeric(str) {
        // Use a regular expression to check if the string contains only letters and numbers
        return /^[a-z0-9]+$/i.test(str);
    }

    isValidMPANCore(mpan) {

        var numberRegex = /^(1[0-9]|2[0-7])\d{11}$/; //Core
        return numberRegex.test(mpan);

    }

    validateSupplier(str) {
        if (str.length < 5) {
            return "String must be at least 5 characters in length.";
        }
        if (str === "TBC" || str === "Unknown" || str === "N/A" || str === "Don't Know" || str === "....." || str === "?????") {
            return "Invalid input, Please provide a valid answer.";
        }
        return "Valid";
    }

    handleAddMeter = (name, value) => {

        if (
            !(this.state.utility.length > 0 && 
            (this.state.customerId === "4799" || this.state.mpanmpr.length > 0) &&
            (this.state.customerId === "4799" || this.state.supplierName.length > 0) && 
            this.state.openingMeterReads.length > 0 && 
            this.state.meterserial.length > 0)
        ) {
            toast.error('Please enter all meter details before submission', {
                position: toast.POSITION.TOP_CENTER,
                delay: 50
            });
        } else if (this.state.customerId !== "4799" && this.validateSupplier(this.state.supplierName) !== "Valid") {
            toast.error('Please check supplier details ' + this.validateSupplier(this.state.supplierName), {
                position: toast.POSITION.TOP_CENTER,
                delay: 50
            });
        }
        else {

            if ((this.state.utility === "elec" && this.state.mpanmpr.length === 13 && this.isValidMPANCore(this.state.mpanmpr))||this.state.customerId === "4799") {
                //Va;id
            } else if (this.state.utility === "elec" && this.state.mpanmpr.length === 13 && !this.isValidMPANCore(this.state.mpanmpr)) {
                toast.error('The MPAN/MPR is invalid - Core must be 13 digits starting from 10 to 38', {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });

                return;
            } else if (this.state.utility === "elec") {
                let lvErrorMessage = "";

                if (this.state.mpanmpr.length <= 13) {
                    lvErrorMessage = "Too Short.";

                    toast.error('The MPAN/MPR is invalid -' + lvErrorMessage, {
                        position: toast.POSITION.TOP_CENTER,
                        delay: 50
                    });

                    return;
                }
                if (this.state.mpanmpr.charCodeAt(0) !== 83) {
                    lvErrorMessage = "SNUM must begin with a letter 'S'.";
                }

                if (this.state.mpanmpr.length !== 22) {
                    lvErrorMessage = "SNUM must be 22 characters in length.";
                }

                if (parseInt(this.state.mpanmpr.substring(1, 3)) > 8) {
                    lvErrorMessage = "Profile must be between the range '00 - 08'.";
                }

                if (parseInt(this.state.mpanmpr.substring(1, 6)) === 0) {
                    lvErrorMessage = "Invalid number range from characters 2 - 7.";
                }


                if (lvErrorMessage !== "") {
                    toast.error('The MPAN/MPR is invalid -' + lvErrorMessage, {
                        position: toast.POSITION.TOP_CENTER,
                        delay: 50
                    });

                    return;
                }


            }

            else if (!this.isAlphaNumeric(this.state.mpanmpr)) {
                toast.error('The MPAN/MPR must only contain letters or numbers please check the data entered.', {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });

                return;
            }


            let filtereedArray = this.state.meterListAll.filter(meter => meter.serialNumber === this.state.mpanmpr);

            if (filtereedArray.length > 0) {

                toast.error('Looks like we already have this meter active against your account. Plese verify before continuing', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: false,
                    delay: 50
                });

                //return;
            }

            let reffiltereedArray = this.state.meterListAll.filter(meter => meter.reference === this.state.mpanmpr);

            if (reffiltereedArray.length > 0) {

                toast.error('Looks like we already have this meter active against your account. Plese verify before continuing', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: false,
                    delay: 50
                });

                //return;
            }

            let myArr = [...this.state.meters]



            myArr.push({ id: Math.random(), utility: this.state.utility, mpanmpr: this.state.mpanmpr, meterserial: this.state.meterserial, supplierName: this.state.supplierName, openingMeterReads: this.state.openingMeterReads })
            this.setState({
                meters: myArr
            })



            this.setState({
                [name]: value
            });


            this.setState({
                utility: '',
                mpanmpr: '',
                meterserial: '',
                supplierName: '',
                openingMeterReads: ''
            })
        }
    };

    handleSoldModal = () => {
        this.setState({ showSiteSale: !this.state.showSiteSale })
    }

    handleDocsModal = () => {



        if (this.state.changeRequested === 'moveOut') {
            this.pushAllMeters()
        }

        if (this.state.changeRequested === "removeMeter") {
            if (this.state.metersList.length !== this.state.metersToRemove.length) {
                this.setState({ allMetersConfirm: true })
            } else {
                this.setState({ showSiteDocsWarning: !this.state.showSiteDocsWarning })

            }

        } else {

            this.setState({ showSiteDocsWarning: !this.state.showSiteDocsWarning })
        }
    }

    handleDocsModalClose = () => {


        this.setState({ showSiteDocsWarning: !this.state.showSiteDocsWarning, allowSubmit : true })

    }

    handleChangeChk = () => {
        this.setState({ allowSubmit: !this.state.allowSubmit })
    }

    handleModalMoveOut() {

        this.setState({
            // hideMetersList: true,
            // hideRemoveMetersList : true,
            markSiteAsSold: true,
            showSiteSale: !this.state.showSiteSale//,
            //changeRequested:"moveOut"
        });


    }

    handleCopyContactDetails = (name, value) => {

        


        this.setState({
         
            contactCopied: !this.state.contactCopied//,
        });

        var meterSiteKey = value.name.split("|")[1];

        var newBillingAddressCopy = this.state["newBillingAddress|" + meterSiteKey]
        var newOccupierNameCopy = this.state["newOccupierName|" + meterSiteKey]
        var newOccupierContactCopy = this.state["newOccupierContact|" + meterSiteKey]

        var metersToRemoveObject = this.state.metersToRemoveSubmissionObject

        let filtereedArray = metersToRemoveObject.filter(meter => meter.meterSiteKey !== meterSiteKey);


        let objectAssociatedData = []

        let addMeterBack = metersToRemoveObject.filter(meter => meter.meterSiteKey === meterSiteKey);

        objectAssociatedData.push(addMeterBack[0])

        filtereedArray.forEach(x => {
            objectAssociatedData.push({ id: Math.random(), meterSiteKey: x.meterSiteKey, newBillingAddress: newBillingAddressCopy, newOccupierName: newOccupierNameCopy, newOccupierContact: newOccupierContactCopy, FinalMeterRead: x.FinalMeterRead, fileList: x.fileList })
            this.setState({
                ["newBillingAddress|" + x.meterSiteKey]: newBillingAddressCopy,
                ["newOccupierName|" + x.meterSiteKey]: newOccupierNameCopy,
                ["newOccupierContact|" + x.meterSiteKey]: newOccupierContactCopy

            })


        });




        this.setState({
            metersToRemoveSubmissionObject: objectAssociatedData
        })


    }

    validateMeterForm = () => {
        if ((this.state.changeRequested === 'moveOut' || this.state.changeRequested === 'removeMeter') && this.state.customerId === "4799" ) {

                     console.log(this.state.metersToRemoveSubmissionObject)
            for (let metersToRemove of this.state.metersToRemoveSubmissionObject) {
               
                if( (metersToRemove.newBillingAddress &&  metersToRemove.newOccupierName && metersToRemove.newOccupierContact && metersToRemove.FinalMeterRead))
                {
                    console.log("validateForm - nopt empty")

                if( !(metersToRemove.newBillingAddress.length > 0 &&  metersToRemove.newOccupierName.length > 0 && metersToRemove.newOccupierContact.length > 0 && metersToRemove.FinalMeterRead.length > 0))
                {
                    return false;
                }else
                {
                    console.log("validateForm - lengths ok")
                   

                }
                }else
                {
                    console.log("validateForm - empty")
                    return false;

                }

            }
        }else
        {
            return true
        }

        return true;
    }

    validateForm = () => {

  



        if (this.state.changeRequested === "removeMeter") {
            return this.state.changeDate !== '' && this.state.metersToRemove.length > 0

        } else if (this.state.changeRequested === "newMeter") {
            return this.state.changeDate !== '' 
            && this.state.meters.length > 0
            && (this.state.customerId !== "4799" || this.state.previousOccupierName.length > 0 )
            && (this.state.customerId !== "4799" || this.state.previousOccupierContact.length > 0 )
            && (this.state.customerId !== "4799" || this.state.meterAddress.length > 0 )

            

        } else if (this.state.changeRequested === "Other") {
            return this.state.changeDate !== ''

        } else if (this.state.changeRequested === "moveOut") {
            return this.state.changeDate !== ''

        } else {
            return false
        }
    }

    
    manditoryLabel = (fieldName) => {

        

        switch(this.state.changeRequested) {
            case "removeMeter":
                switch(fieldName) {
                    case 'changeDate':
                    case 'metersToRemove':
                        return '*';
                            case 'FinalMeterRead':
                            case 'newOccupierContact':
                            case 'newOccupierName':
                            case 'newBillingAddress':
                                return this.state.customerId === "4799" ? '*' : '';
                    default:
                        return '';
                }
            case "newMeter":
                switch(fieldName) {
                    case 'changeDate':
                    case 'meters':
                        return '*';
                    case 'previousOccupierName':
                    case 'previousOccupierContact':
                    case 'meterAddress':
                    case 'openingMeterReads':
                    case 'meterserial':
                    case 'utility':
                    case 'FinalMeterRead':
                    case 'newOccupierContact':
                    case 'newOccupierName':
                    case 'newBillingAddress':
                        return this.state.customerId === "4799" ? '*' : '';
                    default:
                        return '';
                }
            case "Other":
            case "moveOut":


            switch(fieldName) {

                case 'changeDate':
                case 'FinalMeterRead':
                case 'newOccupierContact':
                case 'newOccupierName':
                case 'newBillingAddress':
                    return this.state.customerId === "4799" ? '*' : '';
                
                default:

                return '';
            }
               
            default:
                return '';
        }
    }




    handlePauseCotRequest = (event) => {

        this.setState({
            submittingInProgress: true,
        });

        const formData = new FormData();

        formData.append("changeDate", this.state.actualChangeDate);

        if (this.state.changeRequested === 'moveOut') {
            formData.append("comments", this.state.comments + " - " + translateSiteName(this.props.currentSite));
        } else if (this.state.changeRequested === 'Other') {
            formData.append("changeRequested", this.state.changeSummary);

            formData.append("comments", this.state.comments);
        } else {
            formData.append("changeRequested", this.state.changeRequested);

            formData.append("comments", this.state.comments);
        }
        formData.append("changeRequested", this.state.changeRequested);
        formData.append("markSiteAsSold", this.state.markSiteAsSold);
        formData.append("siteId", this.state.params.siteKey);


        formData.append("siteDetailAddress", translateSiteName(this.props.currentSite));

        var subObject = this.state.metersToRemoveSubmissionObject
        subObject.forEach((sub, index) => {
            if (this.state["prevFileList|" + sub.meterSiteKey] !== undefined && this.state["prevFileList|" + sub.meterSiteKey] !== null) {
                sub.fileList = sub.fileList.concat(this.state["prevFileList|" + sub.meterSiteKey])
            }
        })

        var fileListOut = this.state.fileList.concat(this.state.prevFileList)

        formData.append("metersString", JSON.stringify(this.state.meters));
        formData.append("metersToRemoveSubmissionString", JSON.stringify(subObject));
        formData.append("fileString", JSON.stringify(fileListOut));
        formData.append("customerId", authService.getUserData(AuthService.CUSTOMER_ID_KEY));

        if (this.state.params.queue !== undefined) {
            formData.append("previousQueueId", this.state.params.queue);
        }



        // try {
        api.postPauseUpdateSiteRequest(formData)
            .then(verifyRes => {

                if (verifyRes.success) {

                    authService.addCotQueueItem(verifyRes.id, this.state.params.siteKey, this.state.changeRequested, translateSiteName(this.props.currentSite), this.state.params.queue, this.state.actualChangeDate)
                    //authService.addCotQueueItem(verifyRes.id,"New","New Site",this.state.siteAddress,this.state.params.queue,this.state.actualChangeDate)
                    if (this.state.params.queue !== undefined) {
                        authService.removeCotQueueItem(this.state.params.queue, this.state.params.siteKey).then(() => { })
                    }
                    this.setState({
                        open: false,

                        meters: [],
                        fileList: [],
                        metersToRemoveSubmissionObject: [],

                        markSiteAsSold: false,
                        changeRequested: "",
                        comments: "",
                        changeSummary: "",
                        actualChangeDate: "",
                        submittingInProgress: "",
                        allowSubmit: true
                    });

                    // this.notify("Successfully Submitted! Your ref ID is : " + verifyRes.id + "",false,true);
                    this.setOpenClearHistory(verifyRes.id, "true");

                } else {

                  

                    this.setState({
                        open: false,
                    });
                    this.notify("Error submitting - contact IT Helpdesk", true);

                }

            })
            .catch((error) => {
               
                this.setState({
                    open: false,
                });
                this.notify("Unhandled Error - contact IT Helpdesk", true);
            });
    }

    validateAddressDetails(str)
    {

        if (typeof str !== 'string') {
            return "Empty input, please provide a valid answer.";
        }

        str = str.toLowerCase().trim();

        // List of invalid inputs
        const invalidInputs = ["tbc", "unknown", "n/a", "don't know", "...", "???", "none", "null", "empty"];

        // Check for invalid inputs
        if (invalidInputs.includes(str)) {
            return "Invalid input, please provide a valid answer.";
        }

        // Check length of the string
        if (str.length < 3) {
            return "Address must be at least 3 characters in length.";
        }
        
        return "Valid";
    }

    handleAddCotRequest = (event) => {


       
        if ((this.state.changeRequested === 'moveOut' || this.state.changeRequested === 'removeMeter') && this.state.cotsAccess === "supplierCots" ) {

                     
        for (let metersToRemove of this.state.metersToRemove) {
            const occupierNameValidation = this.validateAddressDetails(this.state["newOccupierName|" + metersToRemove.meterSiteKey]);
            if (occupierNameValidation !== "Valid") {
                toast.error('Please check previous occupier name is valid for all meters: ' + occupierNameValidation, {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });
                return false;
            }
    
            const occupierContactValidation = this.validateAddressDetails(this.state["newOccupierContact|" + metersToRemove.meterSiteKey]);
            if (occupierContactValidation !== "Valid") {
                toast.error('Please check previous occupier contact is valid for all meters: ' + occupierContactValidation, {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });
                return false;
            }

            const newBillingAddressValidation = this.validateAddressDetails(this.state["newBillingAddress|" + metersToRemove.meterSiteKey]);
            if (newBillingAddressValidation !== "Valid") {
                toast.error('Please check new billing address is valid for all meters: ' + newBillingAddressValidation, {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });
                return false;
            }
        }

    }
        

        this.setState({
            submittingInProgress: true,
        });

        const formData = new FormData();

        formData.append("changeDate", this.state.actualChangeDate);

        if (this.state.changeRequested === 'moveOut') {
            formData.append("changeRequested", this.state.changeRequested);
            formData.append("comments", this.state.comments + " - " + translateSiteName(this.props.currentSite));
        } else if (this.state.changeRequested === 'Other') {
            formData.append("changeRequested", this.state.changeSummary);

            formData.append("comments", this.state.comments);
        } else {
            formData.append("changeRequested", this.state.changeRequested);

            formData.append("comments", this.state.comments);
        }
        formData.append("markSiteAsSold", this.state.markSiteAsSold);

        formData.append("siteDetailAddress", translateSiteName(this.props.currentSite));


        formData.append("previousOccupierName", this.state.previousOccupierName);
        formData.append("previousOccupierContact", this.state.previousOccupierContact);
        formData.append("meterAddress", this.state.meterAddress);

        

        var subObject = this.state.metersToRemoveSubmissionObject
        subObject.forEach((sub, index) => {
            if (this.state["prevFileList|" + sub.meterSiteKey] !== undefined && this.state["prevFileList|" + sub.meterSiteKey] !== null) {
                sub.fileList = sub.fileList.concat(this.state["prevFileList|" + sub.meterSiteKey])

            }
        })
        var fileListOut = this.state.fileList.concat(this.state.prevFileList)


        formData.append("metersString", JSON.stringify(this.state.meters));
        formData.append("metersToRemoveSubmissionString", JSON.stringify(subObject));
        formData.append("fileString", JSON.stringify(fileListOut));
        formData.append("customerId", authService.getUserData(AuthService.CUSTOMER_ID_KEY));

        if (this.state.params.updateMeterKey !== undefined) {
            formData.append("meterId", this.state.params.updateMeterKey);

        }
        formData.append("siteId", this.state.params.siteKey);

        formData.append("siteRef", this.props.currentSite.locationId);



        if (this.state.params.queue !== undefined) {
            formData.append("previousQueueId", this.state.params.queue);
        }

        // try {
        api.postUpdateSiteRequest(formData)
            .then(verifyRes => {

                if (verifyRes.success) {
                    if (this.state.params.queue !== undefined) {
                        authService.removeCotQueueItem(this.state.params.queue, this.state.params.siteKey).then(() => { })
                    }

                    this.setState({
                        open: false,

                        meters: [],
                        fileList: [],
                        metersToRemoveSubmissionObject: [],
                        previousOccupierName:"",
                        previousOccupierContact:"",
                        meterAddress:"",
                        markSiteAsSold: false,
                        changeRequested: "",
                        comments: "",
                        changeSummary: "",
                        actualChangeDate: "",
                        submittingInProgress: "",
                        allowSubmit: true
                    });


                    //this.notify("Successfully Submitted! Your Case ID is : " + verifyRes.id + "");
                    this.setOpenClearHistory(verifyRes.id, "false");

                } else {


                    this.setState({
                        open: false,
                    });
                    this.notify("Error submitting - contact IT Helpdesk", true);

                }

            })
            .catch((error) => {
                this.setState({
                    open: false,
                });
                this.notify("Unhandled Error - contact IT Helpdesk", true);
            });
    }

    render() {

        const utilityOptions = [
            { key: 'elec', value: 'elec', text: 'Electricity' },
            { key: 'gas', value: 'gas', text: 'Gas' },
            { key: 'water', value: 'water', text: 'Water' }
        ]

        const changeOptions = this.state.customerId === "4799" ? [
            { key: 'newMeter', value: 'newMeter', text: 'COT IN' },
            { key: 'removeMeter', value: 'removeMeter', text: 'COT OUT' },
            { key: 'moveOut', value: 'moveOut', text: 'Building Sale' }
        ] : [
            { key: 'newMeter', value: 'newMeter', text: 'Add a New Meter' },
            { key: 'removeMeter', value: 'removeMeter', text: 'Remove a Meter' },
            { key: 'moveOut', value: 'moveOut', text: 'Move Out' },
            { key: 'other', value: 'Other', text: 'Other Change' }
        ];

        
        const CustomInput = ({ value, onClick }) => (
            <Input fluidvalue={value} value={value} onClick={onClick} icon="calendar" />
        );



        const filePanes = () => {

            return this
                .state
                .metersToRemove
                .map(metersToRemove => ({
                    menuItem: (metersToRemove.serialNumber !== null ? metersToRemove.serialNumber + "-" + metersToRemove.utility : metersToRemove.utility), pane: <Tab.Pane onClick={() => {
                        this.setState({ currentMeterTab: metersToRemove.meterSiteKey })
                    }

                    }>
                        <Header as='h4'>Current Meter Details</Header>

                        <div className="repeater-body">



                            <Segment>

                                {metersToRemove.meterSiteKey + " - " + metersToRemove.utility + " - " + metersToRemove.serialNumber + " - " + metersToRemove.supplyAddress + " - " + metersToRemove.supplier}
                            </Segment>




                        </div>
                        {this.state.cotsAccess === "supplierCots" ?
                                     
                                     <Header as='h4'>Supporting Documents</Header> :
                                     <Header as='h4'>Meter Read Photos</Header> }

                        <FilePond files={this.state["meterFiles|" + metersToRemove.meterSiteKey]} allowFileSizeValidation={true} maxFileSize="7MB" labelMaxFileSizeExceeded="File is too Large" labelMaxFileSize="Maximum file size is {filesize}" onupdatefiles={this.onFilesUpdatedMeters} allowMultiple={true} allowRevert={false} allowRemove={false} allowProcess={false}
                          acceptedFileTypes={[
                            'image/jpeg',
                            'image/png',
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                            'application/vnd.ms-excel', // .xls
                            'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                            'application/msword', // .doc
                            'application/pdf', // .pdf
                            'text/csv', // .csv
                            'image/tiff' // .tif
                        ]}
                        server={{
                            process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                                this.setState({ showInfoHide: true })
                                const formData = new FormData();
                                formData.append(fieldName, file, file.name);
                                formData.append("client", authService.getUserData(AuthService.CUSTOMER_ID_KEY));
                                formData.append("uploadedBy", authService.getUserData(AuthService.EMAIL_KEY));
                                const request = new XMLHttpRequest();

                                //request.open('POST', `${apiUrl}/MeterReads/something/${authService.getUserData(AuthService.CUSTOMER_ID_KEY)}`);
                                request.open('POST', `${apiUrl}/Documents/PublishPrivateDocument`);

                                request.setRequestHeader(
                                    'Authorization', `bearer ${localStorage.getItem("token")}`);

                                request.upload.onprogress = (e) => {
                                    progress(e.lengthComputable, e.loaded, e.total);

                                };

                                request.onload = (e) => {

                                    var obj = JSON.parse(e.srcElement.response);



                                    if (request.status >= 200 && request.status < 300) {

                                        if (obj.hasErrors) {


                                            error("Failed")


                                        } else {

                                            
                                            let myArr = [...this.state.fileList]



                                            myArr.push(obj.fileId)
                                            this.setState({
                                                fileList: myArr
                                            })


                                            let submissionArr = [...this.state.metersToRemoveSubmissionObject]

                                            let filtereedArray = submissionArr.filter(meter => meter.meterSiteKey !== metersToRemove.meterSiteKey);


                                            var firstMSK = submissionArr[0].meterSiteKey



                                            let objectAssociatedData = filtereedArray

                                            var newBillingAddress = this.state["newBillingAddress|" + metersToRemove.meterSiteKey]
                                            var newOccupierName = this.state["newOccupierName|" + metersToRemove.meterSiteKey]
                                            var newOccupierContact = this.state["newOccupierContact|" + metersToRemove.meterSiteKey]
                                            var FinalMeterRead = this.state["FinalMeterRead|" + metersToRemove.meterSiteKey]

                                            let fileList = [...this.state["meterFileStrings|" + metersToRemove.meterSiteKey]]
                                            var prevFileList = []
                                            if (this.state["prevFileList|" + metersToRemove.meterSiteKey] !== undefined) {
                                                prevFileList = [...this.state["prevFileList|" + metersToRemove.meterSiteKey]]
                                            }



                                            fileList.push(obj.fileId)

                                            this.setState(
                                                {
                                                    ["meterFileStrings|" + metersToRemove.meterSiteKey]: fileList,
                                                    ["prevFileList|" + metersToRemove.meterSiteKey]: prevFileList
                                                }
                                            )


                                            if (firstMSK === metersToRemove.meterSiteKey) {
                                                objectAssociatedData.unshift({
                                                    id: Math.random(), meterSiteKey: metersToRemove.meterSiteKey,
                                                    newBillingAddress: newBillingAddress, newOccupierName: newOccupierName, newOccupierContact: newOccupierContact, FinalMeterRead: FinalMeterRead, fileList: fileList
                                                })
                                            } else {
                                                objectAssociatedData.push({
                                                    id: Math.random(), meterSiteKey: metersToRemove.meterSiteKey,
                                                    newBillingAddress: newBillingAddress, newOccupierName: newOccupierName, newOccupierContact: newOccupierContact, FinalMeterRead: FinalMeterRead, fileList: fileList
                                                })
                                            }

                                            // objectAssociatedData.push({ id: Math.random(), meterSiteKey: metersToRemove.meterSiteKey , 
                                            //   newBillingAddress: newBillingAddress, newOccupierName: newOccupierName, newOccupierContact: newOccupierContact, FinalMeterRead: FinalMeterRead, fileList: fileList })


                                            this.setState({
                                                metersToRemoveSubmissionObject: objectAssociatedData,
                                            })




                                            load("Success");
                                        }

                                    }
                                    else {


                                        error('failed upload please check the file format.');
                                    }
                                };

                                request.send(formData);

                                return {

                                    abort: () => {
                                        request.abort();
                                        abort();
                                    }
                                };
                            }
                        }} />

                        {this.state["prevFileList|" + metersToRemove.meterSiteKey] !== undefined && this.state["prevFileList|" + metersToRemove.meterSiteKey].length > 0 &&
                            <Grid.Column>
                                <Header as='h3'>Documents Uploaded Already</Header>

                                {this.state["prevFileNames|" + metersToRemove.meterSiteKey].map((x,index) =>
                                    <Segment key={index} inverted color='green' secondary className='repeater-row'>
                                        <Icon.Group floated="right" size='medium'>
                                            <Icon name='check' />
                                        </Icon.Group> <label> {x} </label>

                                    </Segment>
                                )}

                            </Grid.Column>

                        }

                        <Header as='h4'>Updated Details</Header>

                        {(this.state.metersToRemoveSubmissionObject[0] !== undefined && this.state.contactCopied !== true &&  metersToRemove.meterSiteKey !== this.state.metersToRemoveSubmissionObject[0].meterSiteKey) || (this.state.metersToRemoveSubmissionObject[0] !== undefined && metersToRemove.meterSiteKey === this.state.metersToRemoveSubmissionObject[0].meterSiteKey)  ? <>
                        <Popup content='Where should future bills be addressed to.' trigger={<Input
                            fluid placeholder={'New Billing address'  + this.manditoryLabel("newBillingAddress")} name={"newBillingAddress|" + metersToRemove.meterSiteKey} value={this.state["newBillingAddress|" + metersToRemove.meterSiteKey]} onChange={this.handleMeterArrayChange} />}></Popup>


                        <Popup content='Who is responsible for the property after the COT date' trigger={<Input
                            fluid placeholder={'New Occupier Name'  + this.manditoryLabel("newOccupierName")} name={"newOccupierName|" + metersToRemove.meterSiteKey} value={this.state["newOccupierName|" + metersToRemove.meterSiteKey]} onChange={this.handleMeterArrayChange} />}></Popup>

                        <Popup content='Contact details for the new occupier.' trigger={<Input
                            fluid placeholder={'New Occupier Contact Details'  + this.manditoryLabel("newOccupierContact")} name={"newOccupierContact|" + metersToRemove.meterSiteKey} value={this.state["newOccupierContact|" + metersToRemove.meterSiteKey]} onChange={this.handleMeterArrayChange} />}></Popup>

                        </>
                        :
                        <>
                        
                        <Popup content='Where should future bills be addressed to.' trigger={<Input disabled={true}
                            fluid placeholder={'New Billing address'  + this.manditoryLabel("newBillingAddress")} name={"newBillingAddress|" + metersToRemove.meterSiteKey} value={this.state["newBillingAddress|" + metersToRemove.meterSiteKey]} onChange={this.handleMeterArrayChange} />}></Popup>


                        <Popup content='Who is responsible for the property after the COT date' trigger={<Input  disabled={true}
                            fluid placeholder={'New Occupier Name'  + this.manditoryLabel("newOccupierName")} name={"newOccupierName|" + metersToRemove.meterSiteKey} value={this.state["newOccupierName|" + metersToRemove.meterSiteKey]} onChange={this.handleMeterArrayChange} />}></Popup>

                        <Popup content='Contact details for the new occupier.' trigger={<Input  disabled={true}
                            fluid placeholder={'New Occupier Contact Details'  + this.manditoryLabel("newOccupierContact")} name={"newOccupierContact|" + metersToRemove.meterSiteKey} value={this.state["newOccupierContact|" + metersToRemove.meterSiteKey]} onChange={this.handleMeterArrayChange} />}></Popup>

                        
                        </>
                        }

                        {(() => {
                        
                       if ((this.state.metersToRemoveSubmissionObject[0] !== undefined && metersToRemove.meterSiteKey === this.state.metersToRemoveSubmissionObject[0].meterSiteKey && this.state.metersToRemoveSubmissionObject.length > 0)
                    && (this.state.metersToRemoveSubmissionObject[0].newBillingAddress !== "" && this.state.metersToRemoveSubmissionObject[0].newOccupierContact !== undefined && this.state.metersToRemoveSubmissionObject[0].newOccupierName !== undefined ))
                       {
                        return ( <>
                            <Checkbox onChange={this.handleCopyContactDetails} name={"cb|" + metersToRemove.meterSiteKey} label='Copy billing and contact details to all meters?'></Checkbox>
                            </>
                        )
                       } else if (this.state.metersToRemoveSubmissionObject[0] !== undefined && metersToRemove.meterSiteKey === this.state.metersToRemoveSubmissionObject[0].meterSiteKey)
                           return ( <>
                            <Checkbox disabled={true} onChange={this.handleCopyContactDetails} name={"cb|" + metersToRemove.meterSiteKey} label='Copy billing and contact details to all meters?'></Checkbox>
                            </>
                           )

                        })()}
                        <Popup content='Final meter read before close' trigger={<Input
                            fluid placeholder={'Final Meter Read'  + this.manditoryLabel("FinalMeterRead")} name={"FinalMeterRead|" + metersToRemove.meterSiteKey} value={this.state["FinalMeterRead|" + metersToRemove.meterSiteKey]} onChange={this.handleMeterArrayChange} />}></Popup>

                    </Tab.Pane>
                }))
        }

        return (

            <Button.Group compact floated='right'>

                <Modal
                    open={this.state.allMetersConfirm}
                    size={'mini'}
                >
                    <Modal.Header>Have you checked all meters?</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <p>
                                Are you sure the other meters at this property are not included in the change?
                            </p>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='black' onClick={() => this.setState({ allMetersConfirm: false, showSiteDocsWarning: false })}>Cancel</Button>
                        <Button positive content="Yes"
                            onClick={() => {
                                this.setState({ allMetersConfirm: false, showSiteDocsWarning: true })
                            }}
                        />
                    </Modal.Actions>
                </Modal>

                <Modal size="large"
                    trigger={<Button floated='right' id='upload-meters'>Request Update to Site</Button>}
                    onOpen={() => this.setOpen(true)}
                    open={this.state.meterModalOpen}
                >
                    <Modal.Header>
                        <h2>Update site</h2>
                    </Modal.Header>
                    <Modal.Content>
                        <div>
                            <Segment>

                                <Dimmer active={this.state.submittingInProgress}>
                                    <Loader>Submitting. Note* If you have submitted a lot of meters or files this may take a short time. Please remain on the page to recieve your reference number</Loader>
                                </Dimmer>

                                <Grid.Column>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                    <Dropdown
                                        fluid
                                        selection

                                        disabled={this.state.params.updateMeterKey !== undefined}
                                        placeholder='Please select change you are requested'
                                        options={changeOptions}
                                        value={this.state.changeRequested}
                                        name="changeRequested"
                                        onChange={this.handleChangeOption}
                                    />
                                        <div style={{ width: '20px' }} />  {/* Spacer Div */}
                                        {this.state.changeRequested && 
                                            <>
                                            {this.state.cotsAccess === "supplierCots" ?
                                                    <HelpSection topic={this.state.changeRequested} mode="Small"/>
                                                    :
                                                    <HelpSection topic={this.state.changeRequested + "NonSupplier"} mode="Small"/>

                                           }
                                           </>
                                       }
                             </div>

                           

                                    <Header as='h2'>
                                        {this.state.params.updateMeterKey !== undefined ?

                                            "Details of change to meter:" : "Site Details"
                                        }
                                    </Header>
                                    {this.state.markSiteAsSold &&
                                        <Grid columns={2}>
                                            <Grid.Column><Header color='green' as='h4'>Mark Site As Sold <i className="money bill alternate outline icon"></i></Header></Grid.Column> <Grid.Column>   </Grid.Column>  </Grid>}

                                    {this.state.changeRequested === 'Other' ?
                                        <div>
                                            <Form>

                                                <Popup content='A summary of the change requested' trigger={<Input
                                                    fluid placeholder='A summary of the request....' name="changeSummary" value={this.state.changeSummary} onChange={this.handleChange} />}></Popup><br />

                                                <Popup content='Comments' trigger={<TextArea
                                                    fluid placeholder='Details about the change....' name="comments" value={this.state.comments} onChange={this.handleChange} />}></Popup><br /><br />
                                            </Form>
                                        </div>

                                        :
                                        <div>
                                            <Form>
                                                <Popup content='Comments' trigger={<TextArea
                                                    fluid placeholder='Comments about the change....' name="comments" value={this.state.comments} onChange={this.handleChange} />}></Popup><br /><br />
                                            </Form>
                                        </div>
                                    }



                                    <Header as='h4'>{"Effective from" + this.manditoryLabel("changeDate")}</Header>
                                    <Popup content='Date when you want the change to be effective from' trigger={

                                        <DatePicker selected={this.state.changeDate} locale="en-GB" dateFormat="dd/MM/yyyy" onChange={this.handleDateChange} customInput={<CustomInput />} />

                                    }>

                                    </Popup><br /><br />

                                    <Grid.Column hidden={this.state.hideMoveoutDetails}>
                                        <Header as='h4'>Current Site Name/Address</Header>
                                        <Field value={translateSiteName(this.props.currentSite) || <NoData />} />
                                        <br></br>
                                    </Grid.Column>

                                    {(this.state.changeRequested === "newMeter" && this.state.customerId === "4799") && 

                                    
                                     <>
                                      <Checkbox
                            label="Liquidation/Forfeiture"
                            checked={this.state.isLiquidationForfeiture}
                            onChange={this.handleCheckboxChange}
                        />
                        <br /><br />

                        {!this.state.isLiquidationForfeiture && (
                            <>
                                                <Popup content='Who was responsible for the property before the change date' trigger={<Input
                                                    fluid placeholder={'Previous Occupier Name' + this.manditoryLabel("previousOccupierName")} name="previousOccupierName" value={this.state.previousOccupierName} onChange={this.handleChange} />}></Popup><br /><br />

                                                <Popup content='Contact details for the previous occupier.' trigger={<Input
                                                    fluid placeholder={'Previous Occupier Contact Details' + this.manditoryLabel("previousOccupierContact")} name="previousOccupierContact" value={this.state.previousOccupierContact}  onChange={this.handleChange} />}></Popup><br /><br />


                            </>
                        )}
                                <Popup content='This is where the meter supplies, e.g. 3rd floor Focus House, High Street, London' trigger={
                                <Input
                                    fluid placeholder={'Meter Address' + this.manditoryLabel("meterAddress")} name="meterAddress" value={this.state.meterAddress} onChange={this.handleChange} />}></Popup><br />
                                        </> }

                                    <Grid.Column hidden={this.state.hideRemoveMetersList}>

                                        <Header as='h2'>Meters Available for removal</Header>

                                        <div className="repeater-body">
                                            {this.state.metersList.map((x,index) =>


                                                <Segment key={index}>

                                                    {x.utility + " - " + x.serialNumber + " - " + x.supplyAddress + " - " + x.supplier + " "}
                                                    <Button
                                                        color={this.handleMeterRender(x.meterSiteKey) === true ? 'green' : ''}
                                                        floated='right'
                                                        vertical
                                                        compact
                                                        size='small'
                                                        id={x.meterSiteKey}
                                                        onClick={this.handleMeterRender(x.meterSiteKey) === true ? this.handleRemoveActualMeter : this.handleAddActualMeter}
                                                    >  {this.handleMeterRender(x.meterSiteKey) === true ? 'Selected' : 'Remove Meter'}</Button>



                                                </Segment>



                                            )}
                                        </div>

                                    </Grid.Column>
                                    <Grid.Column hidden={this.state.hideMetersList}>


                                        <Header as='h2'>{"Meters"   + this.manditoryLabel("meters")}</Header>
                                        <Grid columns={2}>
                                            <Grid.Column>

                                                <Select fluid placeholder={'Select Utility'  + this.manditoryLabel("utility")} value={this.state.utility} name="utility" options={utilityOptions} onChange={this.handleDropDownChange} />
                                            </Grid.Column>
                                            <Grid.Column>

                                                <Popup content='This will be located on the bills, and should be provided to you by the outgoing party' trigger={<Input
                                                    fluid
                                                    placeholder='MPAN/MPR'
                                                    name="mpanmpr"
                                                    onChange={this.handleChange}
                                                    value={this.state.mpanmpr}
                                                />}></Popup>
                                            </Grid.Column>
                                            <Grid.Column>

                                                <Popup content='This will be located on the bills, and should be provided to you by the outgoing party' trigger={<Input
                                                    fluid
                                                    placeholder={'Meter Serial Number'  + this.manditoryLabel("meterserial")}
                                                    name="meterserial"
                                                    onChange={this.handleChange}
                                                    value={this.state.meterserial}
                                                />}></Popup>
                                            </Grid.Column>
                                            <Grid.Column>

                                                <Popup content='If known, please confirm the current supplier' trigger={<Input
                                                    fluid
                                                    placeholder='Supplier Name'
                                                    name="supplierName"
                                                    onChange={this.handleChange}
                                                    value={this.state.supplierName}

                                                />}></Popup>

                                            </Grid.Column>
                                            <Grid.Column>

                                                <Popup content='If you are unable to provide these your supplier will estimate the opening read, which may result in over or undercharges' trigger={<Input
                                                    fluid
                                                    placeholder={'Opening Meter Reads'  + this.manditoryLabel("openingMeterReads")}
                                                    name="openingMeterReads"
                                                    onChange={this.handleChange}
                                                    value={this.state.openingMeterReads}

                                                />}></Popup>
                                            </Grid.Column>
                                        </Grid>

                                        <Button className='addMeter'
                                            compact
                                            id='confirm-user'
                                            onClick={this.handleAddMeter}
                                        >Add Meter</Button>

                                        <div className="repeater-body">
                                            {this.state.meters.map((x,index) =>


                                                <Segment key={index}>

                                                    {x.mpanmpr + " - " + x.meterserial + " - " + x.utility + " - " + x.supplierName + " - " + x.openingMeterReads + " "}
                                                    <Button
                                                        negative
                                                        floated='right'
                                                        vertical
                                                        compact
                                                        size='small'
                                                        id={x.id}
                                                        onClick={this.handleRemoveMeter}
                                                    >Remove</Button>



                                                </Segment>

                                            )}
                                        </div>




                                    </Grid.Column>



                                </Grid.Column>

                                <Grid.Column>
                                {this.state.cotsAccess === "supplierCots" ?
                                     
                                     <Header as='h2'>Supporting Documents (Meter read photos, Lease agreement etc)</Header>
                                     :
                                     <Header as='h2'>Meter Read Photos</Header> }
                                    <FilePond onupdatefiles={this.onFilesUpdated} maxFileSize="7MB" labelMaxFileSizeExceeded="File is too Large" labelMaxFileSize="Maximum file size is {filesize}" allowMultiple={true} allowRevert={false} allowRemove={false} allowProcess={false}   acceptedFileTypes={[
                                                    'image/jpeg',
                                                    'image/png',
                                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                                                    'application/vnd.ms-excel', // .xls
                                                    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
                                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                                                    'application/msword', // .doc
                                                    'application/pdf', // .pdf
                                                    'text/csv', // .csv
                                                    'image/tiff' // .tif
                                                ]}
                                                server={{
                                        process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                                            this.setState({ showInfoHide: true })
                                            const formData = new FormData();
                                            formData.append(fieldName, file, file.name);
                                            formData.append("client", authService.getUserData(AuthService.CUSTOMER_ID_KEY));
                                            formData.append("uploadedBy", authService.getUserData(AuthService.EMAIL_KEY));
                                            const request = new XMLHttpRequest();

                                            //request.open('POST', `${apiUrl}/MeterReads/something/${authService.getUserData(AuthService.CUSTOMER_ID_KEY)}`);
                                            request.open('POST', `${apiUrl}/Documents/PublishPrivateDocument`);

                                            request.setRequestHeader(
                                                'Authorization', `bearer ${localStorage.getItem("token")}`);

                                            request.upload.onprogress = (e) => {
                                                progress(e.lengthComputable, e.loaded, e.total);

                                            };

                                            request.onload = (e) => {

                                                var obj = JSON.parse(e.srcElement.response);



                                                if (request.status >= 200 && request.status < 300) {

                                                    if (obj.hasErrors) {


                                                        error("Failed")


                                                    } else {

                                                        let myArr = [...this.state.fileList]

                                                        myArr.push(obj.fileId)
                                                        this.setState({
                                                            fileList: myArr
                                                        })

                                                        load("Success");
                                                    }

                                                }
                                                else {


                                                    error('failed upload please check the file format.');
                                                }
                                            };

                                            request.send(formData);

                                            return {

                                                abort: () => {
                                                    request.abort();
                                                    abort();
                                                }
                                            };
                                        }
                                    }} />
                                </Grid.Column>

                                {this.state.prevFileList !== undefined && this.state.prevFileList.length > 0 &&
                                    <Grid.Column>
                                        <Header as='h3'>Documents Uploaded Already</Header>



                                        {this.state.prevFileNames.map((x,index) =>
                                            <Segment  key={index} inverted color='green' secondary className='repeater-row'>
                                                <Icon.Group floated="right" size='medium'>
                                                    <Icon name='check' />
                                                </Icon.Group> <label> {x} </label>

                                            </Segment>
                                        )}

                                    </Grid.Column>

                                }

                            </Segment>
                        </div>

                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.handlePauseCotRequest()} disabled={!this.validateForm()} >Save and Continue Later</Button>

                        <Button
                            compact
                            id='confirm-user'
                            // disabled={this.state.submittingInProgress}
                            disabled={!this.validateForm()}
                            onClick={this.handleDocsModal}
                        >Continue</Button>
                        <Button color='black' compact onClick={() => this.setOpen(false)}>
                            Dismiss
                        </Button>

                    </Modal.Actions>
                </Modal>

                <Modal open={this.state.showSiteSale} onHide={() => this.handleSoldModal()}>
                    <Modal.Header closeButton>Are you moving out?</Modal.Header>
                    <Modal.Content> <Modal.Description>
                        <p>
                            You have selected all meters from this site. Would you also want to flag the site as sold?
                        </p>
                    </Modal.Description></Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.handleModalMoveOut()}>Yes</Button>
                        <Button onClick={() => this.handleSoldModal()}>No</Button>
                    </Modal.Actions>
                </Modal>


                <Modal size={(this.state.metersToRemoveSubmissionObject[0] !== undefined && this.state.metersToRemoveSubmissionObject.length > 5) ? "fullscreen" : "large"} open={this.state.showSiteDocsWarning} onHide={() => this.handleDocsModal()}>
                    <Dimmer active={this.state.submittingInProgress}>
                        <Loader>Submitting. Note* If you have submitted a lot of meters or files this may take a short time. Please remain on the page to recieve your reference number</Loader>
                    </Dimmer>
                    
{this.state.cotsAccess === "supplierCots" ?
<>
                    {this.state.changeRequested !== 'Other' ?
                        <Modal.Header closeButton>Have you checked the required documentation?</Modal.Header> : <Modal.Header closeButton>Ready to submit?</Modal.Header>
                    }
                    </> :
                    <>
                    {this.state.changeRequested !== 'Other' ?
                        <Modal.Header closeButton>Have you provided all information required?</Modal.Header> : <Modal.Header closeButton>Ready to submit?</Modal.Header>
                    }
                    </>

                }
                    
                    
                    
                    {this.state.changeRequested !== 'Other' && <>


                    {this.state.cotsAccess === "supplierCots" ?
<>
                        <Modal.Content>

                            <Modal.Description>




                                <Tab renderActiveOnly={false} panes={filePanes()} />



                                <Message warning attached='bottom'>
                                    <Icon name='warning' />
                                    Please ensure any required <b>lease agreement</b> has been attatched or there will be potential delays in processing the request
                                </Message>
                                <Message warning attached='bottom'>
                                    <Icon name='warning' />
                                    Please ensure meters being moved out have had the <b>latest meter read photos</b> attatched or there will be potential delays in processing the request
                                </Message>
                                <Checkbox onChange={this.handleChangeChk} label='I confirm I have read the above and have attatched the documents required or accept the processing delay'></Checkbox>

                            </Modal.Description></Modal.Content>  
                            </> :
                            <>
                             <>

<Modal.Content> <Modal.Description>

<Message warning attached='bottom'>
     <Icon name='warning' />
     Please ensure all details you have provided are accurate and correct
                                                                                         </Message>
                                             <Message warning attached='bottom'>
     <Icon name='warning' />
     Please ensure meter read photos have been attached
                                                                                         </Message>
                                             <Message warning attached='bottom'>
     <Icon name='warning' />
     Inenco will not contact the suppliers in relation to this change. If you would like our support with this, please speak to your Account Manager about our Change of Tenancy services
                                                                                         </Message>
 
 <Checkbox  onChange={this.handleChangeChk} label='I confirm I have read the above and have attatched the documents required or accept the processing delay'></Checkbox>
</Modal.Description></Modal.Content>  

</>
                            </>
                            
            }
                            
                            
                            
                            
                             </>}
                    <Modal.Actions>
                        {this.state.changeRequested !== 'Other' ?
                            <>
                                <Button onClick={() => this.handleDocsModalClose()}>Cancel</Button>
                                <Button onClick={() => this.handlePauseCotRequest()}>Save and Continue Later</Button>
                                <Button positive disabled={this.state.allowSubmit || !this.validateMeterForm()} onClick={() => this.handleAddCotRequest()}>{"Submit Request"}</Button>   </>
                                    : <>
                                <Button onClick={() => this.handleDocsModalClose()}>Cancel</Button>
                                <Button onClick={() => this.handlePauseCotRequest()}>Save and Continue Later</Button>
                                <Button positive onClick={() => this.handleAddCotRequest()}>Submit Request</Button> </>}

                    </Modal.Actions>
                </Modal>



            </Button.Group>


        )
    }
}

export default withRouter(UpdateSiteModel);

